export enum ClientPrescriptionMatchKind {
  cePrescriber = 'ce_prescriber',
  internalReferral = 'internal_referral',
}
